export const FEATURES = {
  MEMORY:                'memory',
  BMI_RECHNER:           'bmi_rechner',
  AUDIO_TRANSKRIPTION:   'audio_transkription',
  DIAT_RECHNER:          'diat_rechner',
  SUPPORT_DEVELOPER:     'support_developer',
  FRAG_CHRISTIAN:        'frag_christian',
  GEDANKEN_SORTIERER:    'gedanken_sortierer',
  VERGESSENS_CHECKER:    'vergessens_checker',
  MEETING_ANALYSE:       'meeting_analyse',
  MEETING_VORBEREITUNG:  'meeting_vorbereitung',
  ENTSCHEIDUNGS_HELFER:  'entscheidungs_helfer',
  ANTWORT_GENERATOR:     'antwort_generator',
  SOP_GENERATOR:         'sop_generator',
  EINFACH_ERKLAERER:     'einfach_erklaerer',
  AUFGABEN_UEBERGABE:    'aufgaben_uebergabe',
  REZEPT_GENERATOR:      'rezept_generator',
  IDEEN_EINREICHEN:      'ideen_einreichen',
  VOICE_CART:            'voice_cart',
  PROBLEM_ANALYZER:      'problem_analyzer',
  JOB_KOMPASS:           'job_kompass',
  TEAM_EVENT_PLANUNG:    'team_event_planung',
  ATLAS_SPRACHE:         'atlas_sprache',
  MEETING_LIVE_PROTOKOLL: 'meeting_live_protokoll',
  PRIVAT_BEREICH:        'privat_bereich',
  AKADEMIE_ZUGANG:       'akademie_zugang',
};

export const FEATURE_REGISTRY = [
  {
    id:          FEATURES.MEMORY,
    label:       'TechSoul Memory',
    description: 'Frage dein Wissensarchiv – KI findet relevante Meetings, Entscheidungen und Analysen.',
    route:       '/features/memory',
    icon:        '🧠',
    category:    'analysen',
    area:        'work',
    quickAction: 'Archiv befragen',
  },
  {
    id:          FEATURES.BMI_RECHNER,
    label:       'BMI-Rechner',
    description: 'Berechne und speichere deinen BMI-Verlauf.',
    route:       '/features/bmi',
    icon:        '⚖️',
    category:    'sonstige',
    area:        'life',
  },
  {
    id:          FEATURES.AUDIO_TRANSKRIPTION,
    label:       'Audio-Transkription',
    description: 'Lade Audiodateien hoch und erhalte automatische Transkriptionen.',
    route:       '/features/audio',
    icon:        '🎙️',
    category:    'sonstige',
    area:        'work',
    quickAction: 'Audio hochladen',
  },
  {
    id:          FEATURES.DIAT_RECHNER,
    label:       'Diät-Rechner',
    description: 'Kalorienbedarf, Makronährstoffe und Gewichtsverlauf berechnen.',
    route:       '/features/diat-rechner',
    icon:        '🥗',
    category:    'sonstige',
    area:        'life',
  },
  {
    id:          FEATURES.FRAG_CHRISTIAN,
    label:       'Leadership Coach',
    description: 'Dein persönlicher KI-Führungsassistent – Aufgaben, Entscheidungen, Tagesbriefing.',
    route:       '/features/frag-christian',
    icon:        '🤖',
    category:    'sonstige',
    area:        'work',
  },
  {
    id:          FEATURES.GEDANKEN_SORTIERER,
    label:       'Gedanken-Sortierer',
    description: 'Brain Dump eingeben – KI strukturiert Aufgaben, Prioritäten und nächste Schritte.',
    route:       '/features/gedanken-sortierer',
    icon:        '🧠',
    category:    'analysen',
    area:        'work',
    quickAction: 'Gedanken sortieren',
  },
  {
    id:          FEATURES.VERGESSENS_CHECKER,
    label:       'Vergessens-Checker',
    description: 'Plan prüfen – KI findet fehlende Deadlines, Owner und offene Entscheidungen.',
    route:       '/features/vergessens-checker',
    icon:        '✅',
    category:    'analysen',
    area:        'work',
  },
  {
    id:          FEATURES.MEETING_ANALYSE,
    label:       'Meeting-Analyse',
    description: 'Transkript analysieren – KI extrahiert Entscheidungen, Aufgaben und Follow-ups.',
    route:       '/features/meeting-analyse',
    icon:        '📝',
    category:    'meetings',
    area:        'work',
    quickAction: 'Transkript analysieren',
  },
  {
    id:          FEATURES.MEETING_VORBEREITUNG,
    label:       'Meeting-Vorbereitung',
    description: 'Thema und Ziel eingeben – KI erstellt vollständige Agenda und Strategie.',
    route:       '/features/meeting-vorbereitung',
    icon:        '📅',
    category:    'meetings',
    area:        'work',
    quickAction: 'Agenda erstellen',
  },
  {
    id:          FEATURES.ENTSCHEIDUNGS_HELFER,
    label:       'Entscheidungs-Helfer',
    description: 'Situation beschreiben – KI erstellt Optionsmatrix und Empfehlung.',
    route:       '/features/entscheidungs-helfer',
    icon:        '⚡',
    category:    'entscheidungen',
    area:        'work',
    quickAction: 'Entscheidung analysieren',
  },
  {
    id:          FEATURES.ANTWORT_GENERATOR,
    label:       'Antwort-Generator',
    description: 'Kontext eingeben – KI schreibt E-Mail oder Nachricht im gewünschten Ton.',
    route:       '/features/antwort-generator',
    icon:        '✉️',
    category:    'kommunikation',
    area:        'work',
    quickAction: 'Antwort schreiben',
  },
  {
    id:          FEATURES.SOP_GENERATOR,
    label:       'SOP-Generator',
    description: 'Prozess beschreiben – KI erstellt vollständiges SOP-Dokument.',
    route:       '/features/sop-generator',
    icon:        '📋',
    category:    'dokumente',
    area:        'work',
    quickAction: 'SOP erstellen',
  },
  {
    id:          FEATURES.EINFACH_ERKLAERER,
    label:       'Einfach-Erklärer',
    description: 'Komplexen Text eingeben – KI vereinfacht und erstellt Glossar.',
    route:       '/features/einfach-erklaerer',
    icon:        '💡',
    category:    'analysen',
    area:        'work',
    quickAction: 'Text vereinfachen',
  },
  {
    id:          FEATURES.AUFGABEN_UEBERGABE,
    label:       'Aufgabenübergabe',
    description: 'Standardisierte Aufgaben delegieren, verfolgen und übergeben.',
    route:       '/features/aufgaben-uebergabe',
    icon:        '📤',
    category:    'dokumente',
    area:        'work',
  },
  {
    id:          FEATURES.REZEPT_GENERATOR,
    label:       'KI-Rezeptgenerator',
    description: 'Kühlschrankinhalt eingeben – KI generiert passende Rezepte aus deinen Zutaten.',
    route:       '/features/rezept-generator',
    icon:        '🍳',
    category:    'sonstige',
    area:        'life',
  },
  {
    id:          FEATURES.PROBLEM_ANALYZER,
    label:       'Problem Analyzer',
    description: 'Problem beschreiben – KI analysiert und empfiehlt die passende Problemlösungsmethode (Ishikawa, 5-Why, DMAIC u.v.m.).',
    route:       '/features/problem-analyzer',
    icon:        '🔍',
    category:    'analysen',
    area:        'work',
  },
  {
    id:          FEATURES.VOICE_CART,
    label:       'Sprach-Einkaufsliste',
    description: 'Einkäufe einsprechen – KI erstellt eine korrigierte Liste. Per E-Mail oder WhatsApp versenden.',
    route:       '/features/voice-cart',
    icon:        '🛒',
    category:    'sonstige',
    area:        'life',
  },
  {
    id:          FEATURES.JOB_KOMPASS,
    label:       'Job-Kompass',
    description: 'Lade deinen Lebenslauf hoch – die KI erstellt dein Kompetenzprofil und zeigt, welche Jobrichtungen wirklich zu dir passen.',
    route:       '/features/job-kompass',
    icon:        '🧭',
    category:    'analysen',
    area:        'life',
    isNew:       true,
  },
  {
    id:          FEATURES.TEAM_EVENT_PLANUNG,
    label:       'Team Event Planung',
    description: 'Firmenadresse eingeben – KI zeigt passende Team-Event-Angebote in deiner Umgebung.',
    route:       '/features/team-event-planung',
    icon:        '🎯',
    category:    'sonstige',
    area:        'work',
    isNew:       true,
  },
  {
    id:          FEATURES.IDEEN_EINREICHEN,
    label:       'Ideen einreichen',
    description: 'App-Verbesserungen und Feature-Ideen direkt an den Entwickler senden.',
    route:       '/features/ideen-einreichen',
    icon:        '💡',
    category:    'sonstige',
    area:        'work',
  },
  {
    id:          FEATURES.ATLAS_SPRACHE,
    label:       'Sprachsteuerung',
    description: 'Der Assistent antwortet zusätzlich per Sprache (ElevenLabs TTS). Setzt aktives Leadership-Coach-Feature voraus.',
    icon:        '🔊',
    category:    'sonstige',
    area:        'work',
  },
  {
    id:          FEATURES.MEETING_LIVE_PROTOKOLL,
    label:       'Live-Protokoll (Meeting)',
    description: 'Während der Aufnahme wachsen Protokoll und erkannte Aufgaben live mit. Verbraucht deutlich mehr KI-Tokens.',
    icon:        '📝',
    category:    'sonstige',
    area:        'work',
    // Reifegrad (Wichita): 'beta' = funktioniert, aber noch nicht vollständig getestet.
    // Standard ohne Feld = 'final'. Umschalten auf 'final', sobald durchgetestet.
    maturity:    'beta',
  },
  {
    id:          FEATURES.PRIVAT_BEREICH,
    label:       'Privat',
    description: 'Persönliche Erinnerungen (Geburtstage, Jahrestage) und wiederkehrende Aufgaben (Garten, Haus) — damit du im Arbeitsalltag dein Privatleben nicht vergisst.',
    route:       '/features/privat',
    icon:        '🏡',
    category:    'sonstige',
    area:        'work',
    quickAction: 'Erinnerung anlegen',
    maturity:    'beta',
  },
  {
    id:          FEATURES.AKADEMIE_ZUGANG,
    label:       'Führungsakademie',
    description: 'Mini-Akademie für Führungskompetenzen: kurze Lektionen zu Stress, Delegation, Kritikgesprächen u. v. m. — mit persönlichem KI-Feedback zu Übungen.',
    route:       '/features/akademie',
    icon:        '🎓',
    category:    'analysen',
    area:        'work',
    quickAction: 'Lernen',
    maturity:    'beta',
  },
  {
    id:          FEATURES.SUPPORT_DEVELOPER,
    label:       'Unterstütze den Entwickler',
    description: 'Hilf dabei, Hosting- und Lizenzkosten zu decken.',
    route:       '/features/support',
    icon:        '❤️',
    category:    'sonstige',
    alwaysLast:  true,
  },
];
